angular.module('webtrader').component('valueManager', {
  bindings: {
    value: '=',
    params: '<',
  },
  templateUrl: BASE_URL+'templates/component.valueManager.html',
  controller: function () {
    this.defaults = {
      max: Infinity,
      min: 0,
      modifier: 0.01,
      precision: 0
    }

    this.opts = _.assignIn(this.defaults, this.params)

    this.increase = () => {
      this.value = Number(Math.min(Number(this.value) + this.opts.modifier, this.opts.max))
        .toFixed(this.opts.precision)
    }
    this.decrease = () => {
      this.value = Number(Math.max(Number(this.value) - this.opts.modifier, this.opts.min))
        .toFixed(this.opts.precision)
    }
  }
})